export default __webpack_public_path__ + "static/media/InnerTune6.844af5e3.png";